import ShowHousesGiantsysTracking from "../../concepts/giantsys-tracking/components/templates/ShowHouseGiantsysTracking";

const ShowHouseFields = () => {
  return (
    <ShowHousesGiantsysTracking />
  );
};

export default ShowHouseFields;